import logo from './images/ripss-logo.png'
const Home2 = () => {
    const pageStyle = {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        textAlign: 'center',
        minHeight: '100vh',  // Ensure the div takes up the full height of the viewport
        fontFamily: 'Arial, sans-serif',
      };
      const headingStyle = {
        fontWeight: 600,
        fontSize: '2.5rem', // Adjust font size as needed
        // marginBottom: '10px', // Optional: Add margin bottom for spacing
      };
    
    return (
        <div style={pageStyle}>
            <img src={logo} alt="logo"></img>
            <h1 style={headingStyle}>Website Under Maintenance</h1>
            <p style={{ fontSize: "16px", color: "black" }}>Stay tuned, we will be back shortly...</p>
        </div>
    );
}

export default Home2;

